import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const gestorDocumentalImporterSelectors = importerSelectors(
  'gestorDocumental.importer',
);

export default gestorDocumentalImporterSelectors;
